var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTableSplitCells(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3H3C2.45 3 2 3.45 2 4V20C2 20.55 2.45 21 3 21H21C21.55 21 22 20.55 22 20V4C22 3.45 21.55 3 21 3ZM20 19H13V17H11V19H4V5H11V7H13V5H20V19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.59 11H9.41L10.71 9.71L9.29 8.29L5.59 12L9.29 15.71L10.71 14.29L9.41 13H14.59L13.29 14.29L14.71 15.71L18.41 12L14.71 8.29L13.29 9.71L14.59 11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTableSplitCells);
export default __webpack_public_path__ + "static/media/icon-table-split-cells.c9d91e1a9a0c3749655a111cc97b7d1f.svg";
export { ForwardRef as ReactComponent };